<template functional>
    <div>
        <translate v-if="props.state === 'cancelled'" path="Cancellation.cancelled.text" tag="p"/>
        <translate v-else-if="props.state === 'expired'" path="Cancellation.expired.text" tag="p"/>
        <translate v-else-if="props.state === 'notCancellable'" path="Cancellation.notCancellable.text" tag="p"/>
        <translate v-else-if="props.state === 'notCancellableBooking'" path="Cancellation.notCancellableBooking.text" tag="p"/>
        <translate v-else-if="props.state === 'rejectedBid'" path="Cancellation.rejectedBid.text" tag="p"/>
        <translate v-else-if="props.state === 'consumed' && props.valueVoucher" path="Cancellation.consumed.text" tag="p"/>
        <translate v-else-if="props.state === 'consumed' && !props.valueVoucher" path="Cancellation.cancellationViaServiceOnly.text" tag="p"/>
        <translate path="Cancellation.contact" tag="p">
            <template v-slot:phone>
                <strong>{{props.supportPhone}}</strong>
            </template>
            <template v-slot:email>
                <strong>{{props.supportEmail}}</strong>
            </template>
        </translate>

        <div class="text-center">
            <button class="btn btn-primary text text-uppercase" @click="listeners.back">
                {{parent.$t('Generic.goback')}}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NonCancelableText',
        props: {
            state: String,
            productData: Object,
            valueVoucher: Boolean,
            supportPhone: String,
            supportEmail: String
        }
    }
</script>

